import React, { useState } from 'react';

export default function LocationPicker({ onLocationSelect }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [address, setAddress] = useState('');

  const handleUseLocation = () => {
    setLoading(true);
    setError('');

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          // Note: Remember to move this API key to your .env file later!
          const res = await fetch(
            `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=19b30ecb47f3459995cb9b829b42c0f0`
          );
          const data = await res.json();
          const formatted = data.results[0]?.formatted;
          
          if (formatted) {
            setAddress(formatted);
            // Pass the data back to whatever parent component is using this tool
            if (onLocationSelect) {
              onLocationSelect({ address: formatted, lat: latitude, lng: longitude });
            }
          } else {
            setError('Unable to retrieve address from coordinates.');
          }
        } catch (err) {
          console.error('OpenCage API error:', err);
          setError('Failed to fetch address. Please try again.');
        } finally {
          setLoading(false);
        }
      },
      (geoError) => {
        console.error('Geolocation error:', geoError);
        setError('Location access denied or unavailable.');
        setLoading(false);
      }
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <input
        type="text"
        placeholder="Enter your address or use location"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ccc', width: '100%' }}
      />
      <button
        type="button"
        onClick={handleUseLocation}
        disabled={loading}
        style={{
          padding: '10px',
          borderRadius: '8px',
          border: 'none',
          background: '#5A6993',
          color: 'white',
          fontWeight: 'bold',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.7 : 1
        }}
      >
        {loading ? 'Locating...' : '📍 Use My Location'}
      </button>
      {error && <p style={{ color: 'red', fontSize: '0.8rem', margin: 0 }}>{error}</p>}
    </div>
  );
}